import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { BasePostProvider } from "@tendercuts/http";
import { GenericServerResponse } from "@tendercuts/models";

@Injectable({
  providedIn: "root",
})
export class ReplaceOrderService extends BasePostProvider<GenericServerResponse> {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint,
  ) {
    super(http);
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof GenericServerResponse {
    return GenericServerResponse;
  }

  get endpoint(): string {
    return this.endpointService.replaceOrder();
  }

  get isCachable(): boolean {
    return false;
  }

  getParams(
    incrementId: string,
    productId: any,
    datetype: string,
    slotId: number,
  ): {
    order_id: string;
    product_ids: any;
    delivery_date: string;
    slot_id: number;
  } {
    const params: {
      order_id: string;
      product_ids: any;
      delivery_date: string;
      slot_id: number;
    } = {
      order_id: incrementId,
      product_ids: productId,
      delivery_date: datetype,
      slot_id: slotId,
    };

    return params;
  }
}
